import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { doDoorRing, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { RoomAfterEventsBTNS } from "./V3";
import Game from "../../src/shell/Game";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

export const AnnAfterTODLove1 = async (): Promise<any> => {
    if (Question.globalAnswers.afterTODEnteredNaked) {
        ImageClass.setImage(images.v1.RoomLookingAtPhone2);
        mc.think(`That didn't sound very positive.`);
        mc.think(`I can do nothing about it now.`);
        ImageClass.setImage(images.v1.RoomAlone_2, { transition: true });
        doDoorRing();
        mc.think(`Ann is here.`);
        mc.think(`Let's see what she has to say.`);
        ImageClass.setImage(images.v3.AnnRoom2, { transition: true });
        ann.talk(`Here we are in your room again...`);
        mc.talk(`What did you want to talk about?`);
        ann.talk(`I wanted to say that I get it.`);
        mc.talk(`Get what?`);
        ImageClass.setImage(images.v3.AnnRoom1);
        ann.talk(`I get it that you are a man...`);
        ann.talk(`And you have needs.`);
        ann.talk(`And I acted like a little child when I ran away...`);
        ann.talk(`I mean...`);
        ImageClass.setImage(images.v3.AnnRoom2);
        ann.talk(`I still think it was a jerk move.`);
        ann.talk(`You shouldn't have done it.`);
        return jump(AnnAfterTODLove1_Question, "AnnAfterTODLove1_Question");
    } else {
        ImageClass.setImage(images.v1.RoomLookingAtPhone2);
        mc.think(`She is so cute.`);
        mc.think(`I can see she is totally into me.`);
        mc.think(`It's the perfect opportunity to take our relationship to the next level.`);
        mc.think(`She should be here soon.`);
        ImageClass.setImage(images.v1.RoomAlone_2, { transition: true });

        doDoorRing();
        mc.think(`Ann is here.`);
        doWaitImageByTime(images.v3.AnnRoom2);
        // TODO: do expression
        ann.talk(`I was just here a few hours ago. It's like I never left! Hehe.`);
        mc.talk(`Did your parents get mad for you not coming home?`);
        ImageClass.setImage(images.v3.AnnRoom1, { transition: true });
        ann.talk(`Yes...`);
        ann.talk(`But I understand them, I should have called.`);
        ann.talk(`I didn't know I'd fall asleep.`);
        ImageClass.setImage(images.v3.AnnRoom2, { transition: true });
        ann.talk(`But we talked and it's behind us now.`);
        ann.talk(`Next time I'll just let them know in advance.`);
        mc.talk(`Oh ok.`);
        ann.talk(`But it was worth it.`);
        ann.talk(`It was nice sleeping beside you hehe.`);
        ann.talk(`I mean, I didn't know you entered the bed, but it was nice seeing you there when I woke up.`);
        ann.talk(`I can get used to it.`);
        ann.talk(`I know I'm quite slow when it comes to new relationships.`);
        ann.talk(`And I appreciate you letting me take my time.`);
        ann.talk(`But I want to show you how much I like you.`);
    }

    return jump(AnnAfterTODLove2, "AnnAfterTODLove2");
};

export const AnnAfterTODLove1_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnRoom2);

    await ann.setQuestion(new Question({ text: `You should have just woken me up and talked to me or something...\nI dunno...`, key: `v3AnnAtMcTalking` })
        .option({ title: `Let her talk`, key: `letHerTalk` })
        .option({ title: `Vanessa told me to do it`, key: `vanessaToldMeTo` })
        .option({ title: `You are overreacting`, key: `youAreOverreacting` }));


    if (Question.globalAnswers.v3AnnAtMcTalking === "letHerTalk") {
        ann.talk(`But it made me realize some things...`);
        ann.talk(`You have needs that I don't fulfill.`);
        ann.talk(`If I keep acting like my usual self you will just move on like the other guys.`);

        ImageClass.setImage(images.v3.AnnRoom1);
        ann.talk(`That doesn't mean I'm going to completely change!`);
        ann.talk(`But I think that I'm at that point that I need to stop acting like I do.`);
    } else if (Question.globalAnswers.v3AnnAtMcTalking === "vanessaToldMeTo") {
        await mc.set((properties) => {
            properties.alpha--;
        });
        mc.talk(`Vanessa told me to do it.`);
        ImageClass.setImage(images.v3.AnnRoom2);
        ann.talk(`Vanessa?`);
        mc.talk(`Yes.`);
        mc.talk(`After you left she dared me to get into the bed naked next to you.`);
        ann.talk(`Sounds like something she might suggest...`);
        ann.talk(`And I understand her.`);
        mc.talk(`Really? Aren't you mad?`);
        ImageClass.setImage(images.v3.AnnRoom1);
        ann.talk(`I was, but I had some time to think.`);
    } else {
        await mc.set((properties) => {
            properties.alpha++;
        });
        mc.talk(`You are overreacting.`);
        mc.talk(`What's the big deal?`);
        ImageClass.setImage(images.v3.AnnRoom2);
        ann.talk(`It was a big deal!\nYou can't just sleep next to someone naked!`);
        mc.talk(`You fell asleep in my room.`);
        mc.talk(`And that's how I sleep.`);
        ann.talk(`That's not the point.`);
        mc.talk(`So?`);
        ImageClass.setImage(images.v3.AnnRoom1);
        ann.talk(`Stop!`);
        ann.talk(`Let me finish, you are ruining it.`);
        mc.talk(`...`);
        ann.talk(`So I had some time to think...`);
    }

    ImageClass.setImage(images.v3.AnnRoom2);
    ann.talk(`Vanessa keeps telling me that I need to let go of some of my principles.`);
    ann.talk(`It's hard for me to say it, but I think she might be right.`);
    ImageClass.setImage(images.v3.AnnRoom1);
    ann.talk(`I came here with a goal.`);
    ann.talk(`And...`);
    ImageClass.setImage(images.v3.AnnRoom2);
    ann.talk(`I'm going to give you what you want.`);
    ann.talk(`Or at least try...`);

    return jump(AnnAfterTODLove2, "AnnAfterTODLove2");
};

export const AnnAfterTODLove2 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnRoom1);
    ann.talk(`But please, I'm not fully ready. So let me take my time.`);
    mc.think(`She clearly had some time to think this through.`);
    mc.think(`I wonder what she is planning.`);
    ImageClass.setImage(images.v3.AnnRoom2);
    ann.talk(`Is that ok?`);
    mc.talk(`Yes.`);
    ann.talk(`It might not be a big deal for you, but it is for me...`);
    ann.talk(`Just don't laugh at me for being so dramatic...`);
    mc.talk(`I won't.`);
    ImageClass.setImage(images.v3.AnnRoom3);
    mc.think(`She is taking off her shirt.\nAnd she seems happy doing it.`);
    mc.think(`I guess I met her at the best time, just when she is ready to start making some changes in her lifestyle.`);
    ImageClass.setImage(images.v3.AnnRoom4, { duration: 0.7 });
    ann.talk(`So this is my bra...`);
    mc.talk(`I like it.`);
    ann.talk(`This is so embarrassing but I'm not going to back out now.`);
    if (Question.globalAnswers.afterTODEnteredNaked) {

        mc.think(`Vanessa really knows what she is talking about.`);
        mc.think(`Sleeping naked next to her was really worth it.`);
    }

    return jump(AnnAfterTODLove2_Question1, "AnnAfterTODLove2_Question1");

};

export const AnnAfterTODLove2_Question1 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnRoom4, { duration: 0.7 });
    await ann.setQuestion(new Question({ text: `I'm going to take off my jeans.`, key: `v3AnnTakingJeansOff` })
        .option({ title: `Take everything off`, key: `takeEverythingOff` })
        .option({ title: `Take your time`, key: `takeYourTime` }));

    if (Question.globalAnswers.v3AnnTakingJeansOff === "takeEverythingOff") {
        await mc.set((properties) => {
            properties.alpha++;
        });
        await ann.set((properties) => {
            properties.corruption++;
        });
        mc.talk(`Take everything off.`);
        ann.talk(`No!`);
        ann.talk(`I said I need time.`);
        mc.talk(`Fine.`);
    } else {

        mc.talk(`That's fine.\nTake you time.`);
    }

    ImageClass.setImage(images.v3.AnnRoom5);

    mc.think(`She unbuttoned her jeans.`);
    mc.think(`She gave me a naughty look.\nIt's like the bad side of her was coming out as she was undressing.`);
    mc.think(`There is one thing I'm sure of, if the girl has matching underwear she is ready to show them off.`);


    mc.talk(`You have a great body.`);
    mc.talk(`Though it's hard to see it with all those clothes on.`);
    ann.talk(`Hehe. Thanks, but it will take me some time to feel comfortable like that.`);
    ImageClass.setImage(images.v3.AnnRoom6);
    ann.talk(`Can you... Undress as well?`);
    mc.talk(`Yes.`);
    mc.think(`Finally!`);
    ann.talk(`Can we sit on the bed?`);
    mc.talk(`Of course.`);

    ImageClass.setImage(images.v3.AnnRoom7);
    ann.talk(`So here we are...`);
    ann.talk(`${mc.name}...`);
    ImageClass.setImage(images.v3.AnnRoom7);
    ann.talk(`I don't have much experience but I want to make you feel good...`);
    ImageClass.setImage(images.v3.AnnRoom8);
    ann.talk(`Just tell me if I'm doing something wrong.`);
    ann.talk(`I want to do a good job!`);
    ann.talk(`Can I...`);
    ann.talk(`Touch it?`);

    if (mc.properties.alpha > 1) {

        mc.talk(`I am waiting.`);
    } else {

        mc.talk(`Yes.`);
    }

    ImageClass.setImage(images.v3.AnnRoom9);
    ann.talk(`It's soft.`);
    ImageClass.setImage(images.v3.AnnRoom10, { duration: 0.6 });
    ann.talk(`Oh!`);
    ann.talk(`That didn't take long, hehe.`);
    if (mc.properties.alpha >= 1) {

        mc.talk(`Because I'm so horny.`);
        ann.talk(`Oh.`);
        mc.talk(`Grab it.`);
    } else {


        mc.talk(`Because I'm attracted to you.`);
        ann.talk(`Hehe.`);
        ann.talk(`Can I grab it?`);
        mc.talk(`Yes.`);
    }
    ImageClass.setImage(images.v3.Anim_AnnRoom1.poster, { duration: 0.8 });
    ann.talk(`Hehe, it's warm...`);
    mc.talk(`Start stroking it.`);
    ImageClass.setAnimation(images.v3.Anim_AnnRoom1);
    mc.think(`Ann was stroking my cock.`);
    mc.think(`It felt nice.`);
    mc.think(`But not nice enough for me to cum.`);
    mc.think(`I could clearly feel she lacked experience...`);

    return jump(AnnAfterTODLove2_Question2, "AnnAfterTODLove2_Question2");
};

export const AnnAfterTODLove2_Question2 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnRoom12);
    await ann.setQuestion(new Question({ text: `I hope it feels good...`, key: `v3HJGuidedAnn` })
        .option({ title: `Guide her`, key: true })
        .option({ title: `Let her do it`, key: false }));


    if (Question.globalAnswers.v3HJGuidedAnn) {
        ImageClass.setImage(images.v3.AnnRoom13);
        mc.talk(`You should grab it like so.`);
        mc.talk(`Now, hold it tight, but not too tight.`);
        ImageClass.setImage(images.v3.Anim_AnnRoom2.poster, { duration: 1 });
        ann.talk(`Oh ok.`);
        mc.talk(`Then stroke it.`);
        mc.talk(`But faster this time.`);

        ImageClass.setAnimation(images.v3.Anim_AnnRoom2, { duration: 0 });
        ann.talk(`Like this?`);
        mc.talk(`Yes, exactly.`);
    } else {
        mc.think(`I don't want her to lose confidence.`);
        mc.talk(`Yes, it does.`);
        ann.talk(`I'm a natural! Hehe.`);
        ImageClass.setAnimation(images.v3.Anim_AnnRoom2);
    }

    ann.talk(`It's not that bad.`);
    ann.talk(`It's actually nice.`);
    ann.talk(`I can get used to it, hehe.`);
    ann.talk(`I like making you feel good.`);
    return jump(AnnAfterTODLove2_Question3, "AnnAfterTODLove2_Question3");
};

export const AnnAfterTODLove2_Question3 = async (): Promise<any> => {
    ImageClass.setAnimation(images.v3.Anim_AnnRoom2);
    await mc.setQuestion(new Question({ text: `Hand job is nice but maybe I can convince her to give me a blowjob.`, options: { think: true }, key: `v3ConvincedAnnBJ` })
        .option({ title: `Try to convince her`, key: true })
        .option({ title: `Let her continue`, key: false }));


    if (Question.globalAnswers.v3ConvincedAnnBJ) {
        await ann.set((properties) => {
            properties.corruption++;
        });
        await mc.set((properties) => {
            properties.alpha++;
        });
        return jump(AnnAfterTODLoveBJ, "AnnAfterTODLoveBJ");
    } else {
        return jump(AnnAfterTODLoveBJNothing, "AnnAfterTODLoveBJNothing");
    }
};
export const AnnAfterTODLoveBJ = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnRoom12);
    mc.talk(`You can make me feel even better.`);
    ann.talk(`Really? How?`);
    mc.talk(`With your mouth.`);
    ImageClass.setImage(images.v3.AnnRoom14);
    ann.talk(`Right now?`);
    mc.talk(`Just try to fit it in your mouth.`);


    ann.talk(`No... I was just planning to touch it... With my hands.`);
    ImageClass.setImage(images.v3.AnnRoom15);
    mc.talk(`Don't you want me to enjoy it?`);
    ann.talk(`I do...`);
    ann.talk(`Well...`);
    ann.talk(`I guess I can give it a small kiss.`);
    ann.talk(`But just a kiss!`);

    return jump(AnnAfterTODLoveBJ_Question, "AnnAfterTODLoveBJ_Question");
};

export const AnnAfterTODLoveBJ_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnRoom16);
    await mc.setQuestion(new Question({ text: `A kiss is nice but...`, options: { think: true }, key: `v3ShovedAnnHeadForBJ` })
        .option({ title: `Shove her head onto your dick`, key: true })
        .option({ title: `Do nothing`, key: false }));


    if (Question.globalAnswers.v3ShovedAnnHeadForBJ) {
        await mc.set((properties) => {
            properties.alpha += 2;
        });
        await ann.set((properties) => {
            properties.corruption += 3;
        });
        ImageClass.setImage(images.v3.AnnRoom17);
        ann.talk(`MMMmmm!!!`);
        ImageClass.setImage(images.v3.AnnRoom18);
        ann.talk(`That wasn't very nice...`);
        mc.talk(`I couldn't help myself.`);
        return jump(AnnAfterTODLoveBJ_Question2, "AnnAfterTODLoveBJ_Question2");
    } else {
        ann.talk(`Muah!`);
        ImageClass.setImage(images.v3.AnnRoom12);
        ann.talk(`Hehe, it wasn't that bad.`);
        mc.talk(`You see.`);
        ann.talk(`Yeah, hehe.`);
    }
    return jump(AnnAfterTODLoveBJNothing, "AnnAfterTODLoveBJNothing");
};

export const AnnAfterTODLoveBJ_Question2 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnRoom18);

    await ann.setQuestion(new Question({ text: `I just asked you to give me time.`, key: `v3ApologizedAfterShove` })
        .option({ title: `Apologize`, key: true })
        .option({ title: `Don't apologize`, key: false }));


    if (Question.globalAnswers.v3ApologizedAfterShove) {
        await mc.set((properties) => {
            properties.alpha--;
        });
        await ann.set((properties) => {
            properties.corruption--;
        });
        mc.talk(`I'm sorry.`);
        ImageClass.setImage(images.v3.AnnRoom19);

        ann.talk(`I won't lie, it wasn't that bad.`);
        ann.talk(`But it wasn't nice that you didn't ask me first...`);
        ann.talk(`I am not sure what I need to do right now...`);
        mc.talk(`I said I am sorry, please continue.`);
        ann.talk(`Alright, but don't do that again ok?`);
        mc.talk(`I won't.`);

        ImageClass.setAnimation(images.v3.Anim_AnnRoom2);

        mc.think(`Ann kept stroking my cock for a few minutes...`);

        ann.talk(`Are you close?`);
        mc.talk(`Keep going.`);

    } else {

        await mc.set((properties) => {
            properties.alpha++;
        });
        await ann.set((properties) => {
            properties.corruption += 2;
        });
        ImageClass.setImage(images.v3.AnnRoom19);
        mc.talk(`Relax it's not a big deal.`);
        ann.talk(`It is for me...`);
        ImageClass.setImage(images.v3.AnnRoom18);
        ann.talk(`I don't know what I should do now.`);
        mc.talk(`Just continue I won't do that again.`);
        ImageClass.setImage(images.v3.AnnRoom19);
        ann.talk(`Promise?`);
        mc.talk(`Yes.`);

        ImageClass.setAnimation(images.v3.Anim_AnnRoom2);

        mc.think(`Ann kept stroking my cock for a few minutes...`);
        ann.talk(`Are you close?`);
        mc.talk(`Keep going.`);
    }

    return jump(AnnAfterTODLoveBJNothing, "AnnAfterTODLoveBJNothing");
};


export const AnnAfterTODLoveBJNothing = async (): Promise<any> => {
    ImageClass.setAnimation(images.v3.Anim_AnnRoom2);

    ann.talk(`My hand's starting to hurt.`);
    if (Question.globalAnswers.v4GuidedLateGFAnnOnHJ || Question.globalAnswers.v3HJGuidedAnn) {
        mc.talk(`Just a little more, I'm close.`);
        mc.think(`She is doing a good job. I'm about to cum.`);
    } else {
        mc.talk(`Just a little more.`);
        mc.think(`She is trying her best, but I need more time to cum.`);
    }

    ann.talk(`${mc.name}, my hand is really tired.`);
    if (Question.globalAnswers.v4GuidedLateGFAnnOnHJ || Question.globalAnswers.v3HJGuidedAnn) {
        mc.talk(`Faster! I'm close!`);
        ImageClass.setAnimation(images.v3.Anim_AnnRoom3);
        mc.think(`I'm so close!`);
        ImageClass.setImage(images.v3.AnnRoom20, { duration: 0.9 });
        mc.talk(`Ahhh...`);
        ann.talk(`Oh!`);
        ImageClass.setImage(images.v3.AnnRoom12);
        ann.talk(`I did it! Hehe.`);
        mc.talk(`Yes you did.`);
        ImageClass.setImage(images.v3.AnnRoom21);
        await ann.setQuestion(new Question({ text: `I got some of it on my finger.`, key: `v3ToldAnnLickCum` })
            .option({ title: `Taste it`, key: true })
            .option({ title: `Say nothing`, key: false }));


        if (Question.globalAnswers.v3ToldAnnLickCum) {
            await ann.set((properties) => {
                properties.corruption += 2;
            });

            mc.talk(`Taste it.`);
            await mc.set((properties) => {
                properties.alpha++;
            });
            ImageClass.setImage(images.v3.AnnRoom22);
            ann.talk(`Taste it?\nAre you sure?`);
            mc.talk(`Yes, do it.`);
            ImageClass.setImage(images.v3.AnnRoom21);
            ann.talk(`I don't know...`);
            mc.talk(`It's not a lot, aren't you curious?`);
            ImageClass.setImage(images.v3.AnnRoom22);
            ann.talk(`I guess I can try.`);
            ImageClass.setImage(images.v3.AnnRoom23);
            ann.talk(`Mmm...`);
            ImageClass.setImage(images.v3.AnnRoom24);
            ann.talk(`It's kinda salty...`);
            ann.talk(`But it's not that bad.`);

            ImageClass.setImage(images.v3.AnnRoom25);
            ann.talk(`It's actually kinda nice.`);
            ann.talk(`Do you like me doing it?`);
            mc.talk(`Very much.`);
            ann.talk(`Great! Hehe.`);

        } else {
            await mc.set((properties) => {
                properties.alpha--;
            });

        }
        await endReplay(replayScenesList.v3AnnMcFirstHJ);
        return jump(AnnHomeEnd, "AnnHomeEnd");

    } else {
        mc.talk(`Don't stop.`);
        ImageClass.setImage(images.v3.AnnRoom10, { duration: 0.6 });
        ann.talk(`I'm sorry but I need to stop.`);
        ImageClass.setImage(images.v3.AnnRoom19);
        ann.talk(`I tried my best I'm sorry...`);
        if (mc.properties.alpha >= 2) {
            ImageClass.setImage(images.v3.AnnRoom18);
            mc.talk(`That's sad.`);
            mc.talk(`You said you want to make me feel good.`);
            mc.talk(`Cumming makes me feel good.`);
            ann.talk(`I'm sorry, I'll do better next time.`);
        } else {
            ImageClass.setImage(images.v3.AnnRoom19);
            mc.talk(`That's fine...`);
            ann.talk(`I wanted to make you feel good.`);
            mc.talk(`You did...`);
            ann.talk(`Ok...`);
        }

    }


    return jump(AnnHomeEnd, "AnnHomeEnd");

};


export const AnnHomeEnd = async (): Promise<any> => {
    if (Question.globalAnswers.v3HJGuidedAnn) {
        ImageClass.setImage(images.v3.AnnRoom26);
        ann.talk(`It was fun!`);
        ann.talk(`I hope you enjoyed it.`);
        mc.talk(`I did.`);

    } else {
        ImageClass.setImage(images.v3.AnnRoom18);
        ann.talk(`It was a mistake...`);
        mc.talk(`Don't say that.`);
        ImageClass.setImage(images.v3.AnnRoom19);
        ann.talk(`You didn't enjoy that at all.`);
        mc.talk(`I did.`);
        ann.talk(`But you didn't cum.`);
        mc.talk(`Next time I will.`);

        ann.talk(`For what it's worth...`);
        ann.talk(`I enjoyed it...`);
        ann.talk(`Even though you didn't...`);
    }
    await endReplay();

    mc.talk(`Was it your first time?`);
    ImageClass.setImage(images.v3.AnnRoom19);
    ann.talk(`First time?`);
    ImageClass.setImage(images.v3.AnnRoom18);
    ann.talk(`Me?`);
    ann.talk(`No...`);
    ImageClass.setImage(images.v3.AnnRoom19);
    ann.talk(`Maybe...`);
    if (Question.globalAnswers.v3HJGuidedAnn) {

        ImageClass.setImage(images.v3.AnnRoom25);
        ann.talk(`But I did a good job! Hehe.`);
        mc.talk(`Yes you did.`);
    } else {
        ImageClass.setImage(images.v3.AnnRoom18);
        ann.talk(`I hope I can do better next time.`);
    }

    if (Question.globalAnswers.v3ShovedAnnHeadForBJ) {
        ImageClass.setImage(images.v3.AnnRoom19);
        ann.talk(`I still don't appreciate that you pushed my head like that.`);
        ann.talk(`But we've already talked about that...`);
        ann.talk(`I don't like to nag...`);
        ann.talk(`...We haven't talked about it...\nBut my life is quickly changing since I've met you.`);

    } else {
        ImageClass.setImage(images.v3.AnnRoom19);
        ann.talk(`You know, my life is becoming really different since I've met you.`);
    }

    ann.talk(`I'm doing things that I don't normally do.`);
    ann.talk(`Even simple things that you might find stupid.\nLike playing truth or dare.`);
    ann.talk(`And there is some other stuff...`);
    return jump(AnnHomeEnd2, "AnnHomeEnd2");
};

export const AnnHomeEnd2 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnRoom19);
    ann.talk(`Like, I've never said it but I consider you my boyfriend.`);
    ann.talk(`I mean, look what we just did...`);
    mc.think(`Wow...I'm thinking she hasn't really had a boyfriend.`);
    ann.talk(`Don't answer just yet.`);
    ann.talk(`But I hope you feel the same.`);
    ImageClass.setImage(images.v3.AnnRoom7);


    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {

        ann.talk(`And there is something I wanted to ask you.`);
        await ann.setQuestion(new Question({ text: `What should I do about Chris?`, key: `v3KeepAnsweringChris` })
            .option({ title: `Answer him`, key: true })
            .option({ title: `Ignore him`, key: false }));


        if (Question.globalAnswers.v3KeepAnsweringChris) {
            mc.talk(`Answer him.`);
            ann.talk(`Really?`);
            mc.talk(`Yeah why not?`);
            ann.talk(`Because you know what he wants...`);
            mc.talk(`I do.`);
            ann.talk(`Alright...`);
            ann.talk(`Do you want me to update you on our conversations?`);
            mc.talk(`Yes, why not.`);
            ann.talk(`It's kinda strange, but I'll do it.`);
            if (Question.globalAnswers.v25JoeTODAgree && !Question.globalAnswers.todBotheredByJoeKiss) {
                ann.talk(`First Joe and now Chris?`);
                ann.talk(`It didn't bother you that Joe kissed me yesterday.`);
                ann.talk(`And you don't care that I'll keep in touch with that bartender?`);
                mc.talk(`I don't.`);
                ann.talk(`I thought men are jealous.`);
                mc.talk(`I'm not like most men.`);
                ann.talk(`Maybe that's why I like you so much. Hehe.`);
            }

        } else {
            mc.talk(`Ignore him.`);
            ann.talk(`That's what I wanted to do anyway.`);
            ann.talk(`It is weird that he keeps messaging me while I'm with you.`);
            ann.talk(`I'll keep ignoring him and I bet he will stop.`);
        }
    }

    if (Question.globalAnswers.todAnnAsksWhyKissVanessa === "IlikeSeeingYouWithGirls") {
        ann.talk(`I just hope you like kissing me more than you like watching me kiss Vanessa.`);
        mc.talk(`I like both.`);
        ann.talk(`Oh... Ok.`);
    }

    ann.talk(`I need to get going now.`);
    ann.talk(`Call me later!`);

    ann.talk(`Bye, ${mc.name}.`);
    mc.talk(`Bye Ann.`);


    return jump(RoomAfterEventsBTNS, "RoomAfterEventsBTNS");

};



